import { useEffect } from "react"
import {
    getFromStorage,
    setToStorage,
} from "../../data/utility/asyncStorageUtils"
import moment from "moment"

/**
 * Note: If you want to use this hook as a timeout, wrap the callback in a useCallback hook.
 */
export const useIntervalPersistent = ({ callback, delayInSec, persistKey }) => {
    const getLastExecutionTime = async () => getFromStorage(persistKey)
    const setLastExecutionTime = async () =>
        setToStorage(persistKey, new Date().toISOString())

    const executeCallback = async () => {
        const lastExecutionTime = await getLastExecutionTime()
        const executeAfter = moment(lastExecutionTime).add(
            delayInSec,
            "seconds"
        )
        if (!lastExecutionTime || executeAfter.isBefore(moment())) {
            await setLastExecutionTime()
            await callback()
        }
    }

    useEffect(() => {
        executeCallback()
    }, [callback])
}
